import React, {useCallback, useContext, useEffect, useState} from 'react';
import { Field } from 'react-final-form';
import RadioButton from './RadioBig';
import Grid from "@material-ui/core/Grid";
import Select from "./Select";
import styled from "styled-components";
import { Trans } from "../utils/i18n";
import {useFormState, useFormStateDispatch} from "../FormComponents/FormState";
import {getCookieValue} from "../utils/getCookieValue";
import {useQuery} from "@tanstack/react-query";


const RequesttypeSelect = React.memo(function ({ requesttypes, doNotResetForm, requesttype, form, problem_2, }) {
    const orderEntryDispatch = useFormStateDispatch();
    const orderEntryState = useFormState();
    const hasSelfRepairRequestType = requesttypes.some(item => item.key === 'self_repair');
    const product = orderEntryState.selectedProduct?.id || orderEntryState?.serialNumber?.product?.id;

        const fetchFlow = useCallback(() => {
            return fetch(route('selfrepair.getFlow') + `?product_id=${product}${problem_2 ? `&problem_id=${problem_2}` : ''}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN'),
                    'X-Requested-With': 'XMLHttpRequest',
                },
            })
                .then(response => response.json());
        }, [product, problem_2]);

        const { data, isLoading } = useQuery({
            queryKey: ['flows', product, problem_2],
            queryFn: fetchFlow,
            enabled: !!product && !!problem_2 && !!hasSelfRepairRequestType,
        });
        const hasSelfRepair = data?.success === true;

        requesttypes = requesttypes.filter(item => item.key !== 'self_repair' || hasSelfRepair);

        useEffect(() => {
            if(requesttypes.length === 1) {
                form.change('requesttype', requesttypes[0].key);
            }
        }, []);

        useEffect(() => {
            if (doNotResetForm) {
                return;
            }

            if (requesttype) {
                form.change('productvariant', undefined)
                form.change('product', undefined)
                form.change('serialnumber', undefined)
                form.change('company_id', undefined);
                form.change('address', undefined);
                form.change('products', undefined);
                orderEntryDispatch({ type: 'setAddresses', value: null });
                orderEntryDispatch({ type: 'setSerialNumber', value: {} });
            }
        }, [requesttype]);

        if(requesttypes.length === 1) {
            return <></>;
        }

        return (
            <div>
                <div>
                    <h3>
                        <Trans i18nKey="orderEntry.requestType">Request Type</Trans>
                    </h3>
                </div>
            <Grid container spacing={3}>
                {
                    requesttypes
                        .map((item) =>
                            <Grid item xs={12} sm={6} key={item.id}>
                                <Field
                                    name={'requesttype'}
                                    type={'radio'}
                                    value={item.key}
                                    //placeholder={field.placeholder}
                                    component={RadioButton}
                                    validate={value => (value ? undefined : <Trans i18nKey="requestTypeSelect.required">Required</Trans>)}
                                    field={{
                                        titel: item.name,
                                        description: item.description,
                                        image: item.image,
                                    }}
                                />
                            </Grid>,
                        )
                }
            </Grid>
            </div>
        );
    },
    function areEqual(prevProps, nextProps) {
        return JSON.stringify(prevProps) === JSON.stringify(nextProps);
    });

export default RequesttypeSelect;
